import { render, staticRenderFns } from "./CourseBySelf.vue?vue&type=template&id=845d86f4"
import script from "./CourseBySelf.vue?vue&type=script&lang=js"
export * from "./CourseBySelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports